
import { defineComponent, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import SpmBadge from '@/components/table-rest-api/SpmBadge.vue';
import {
  getChannelIcon as getChannelIconFromTokens,
  getChannelTagStyleVars,
} from '@/views/automated-scenarios/utils/styleTokens';

interface Funnel {
  id: string | number;
  name: string;
  type: string;
}

export default defineComponent({
  name: 'FunnelsListV2',

  components: {
    Button,
    SpmBadge,
  },

  props: {
    templateConfig: {
      type: Object,
      required: true,
    },
  },

  emits: ['edit-funnel'],

  setup(props, { emit }) {
    const { t } = useI18n();

    const parsedFunnels = computed<Funnel[]>(() => {
      try {
        const config = props.templateConfig;
        if (config && config.funnels && Array.isArray(config.funnels)) {
          return config.funnels.map((funnel: Funnel) => ({
            id: funnel.id,
            name: funnel.name,
            type: funnel.type,
            labelType: t(`templates.channels.${funnel.type}`),
          }));
        }
      } catch (e) {
        console.error('Error parsing template_config JSON:', e);
      }
      return [];
    });

    const editFunnel = (templateId: number, name: string, type: string) => {
      emit('edit-funnel', templateId, name, type);
    };

    /**
     * Get type icon using styleTokens
     */
    const getTypeIcon = (type: string): string => getChannelIconFromTokens(type) || 'fa-solid fa-question';

    /**
     * Get type colors for SpmBadge using styleTokens
     */
    const getTypeColors = (type: string): { bg: string; color: string; borderColor?: string } => {
      const vars = getChannelTagStyleVars(type);
      return {
        bg: vars['--channel-bg'] || 'var(--surface-200)',
        color: vars['--channel-color'] || 'var(--text-color)',
        borderColor: vars['--channel-border'],
      };
    };

    return {
      parsedFunnels,
      t,
      editFunnel,
      getTypeIcon,
      getTypeColors,
    };
  },
});
